import { render, staticRenderFns } from "./PlgPaymentsAntecipate.vue?vue&type=template&id=5ba8c30e&"
import script from "./PlgPaymentsAntecipate.vue?vue&type=script&lang=js&"
export * from "./PlgPaymentsAntecipate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports